import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=8a9a3444&scoped=true&"
import script from "./FeedbackCard.vue?vue&type=script&lang=ts&"
export * from "./FeedbackCard.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=8a9a3444&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9a3444",
  null
  
)

export default component.exports